import { CalendarDay } from '../../github/types';
import { DAY_MS, toUtc } from './dates';

export interface CalendarStats {
    total: number;
    activeDays: number;
    bestDay: CalendarDay | null;
    longestStreak: number;
    currentStreak: number;
}

export const computeStats = (days: CalendarDay[]): CalendarStats => {
    const sorted = [...days].sort((a, b) => a.date.localeCompare(b.date));
    let longest = 0;
    let running = 0;
    let bestDay: CalendarDay | null = null;
    let previous: number | null = null;

    for (const day of sorted) {
        const time = toUtc(day.date);
        const consecutive = previous !== null && time - previous === DAY_MS;
        running = day.count > 0 ? (consecutive ? running + 1 : 1) : 0;
        longest = Math.max(longest, running);
        if (day.count > 0 && (!bestDay || day.count > bestDay.count)) bestDay = day;
        previous = time;
    }

    // Current streak: count back from the latest day; today may not have activity yet.
    let current = 0;
    for (let i = sorted.length - 1; i >= 0; i--) {
        if (sorted[i].count > 0) current++;
        else if (i === sorted.length - 1) continue;
        else break;
    }

    return {
        total: sorted.reduce((sum, day) => sum + day.count, 0),
        activeDays: sorted.filter((day) => day.count > 0).length,
        bestDay,
        longestStreak: longest,
        currentStreak: current,
    };
};
